import { Group, LoadingOverlay, Tabs } from '@mantine/core';
import { useEffect, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { BackButton, TextInput } from '@components';
import { useImporter } from '@hooks/importer';
import { ImporterViewGeneralInfo } from './ImporterViewGeneralInfo';
import { ImporterViewIdentification } from './ImporterViewIdentification';
import { ImporterViewInfo } from './ImporterViewInfo';
import { ImporterViewPOA } from './ImporterViewPOA';

export const ImporterView: React.FC = () => {
  const navigate = useNavigate();
  const { id, tabId } = useParams<{ id: string; tabId?: string }>() as any;
  const { data: importer, isLoading } = useImporter(id);

  const basePath = `/importers/${id}`;

  const activeTab = useMemo(() => tabId || 'general-info', [tabId]);

  useEffect(() => {
    if (!tabId) {
      navigate(`${basePath}/general-info`);
    }
  }, [tabId, navigate]);

  const handleTabChange = (newTab: string) => {
    navigate(`${basePath}/${newTab}`);
  };

  if (!importer) {
    return <LoadingOverlay visible={isLoading} overlayProps={{ radius: 'sm', blur: 2 }} />;
  }

  return (
    <>
      <Group justify="space-between" p="xl">
        <BackButton backPath="/importers"></BackButton>
        <TextInput name="name" label="Importer name" value={importer?.name} disabled />
      </Group>
      <Tabs value={activeTab} onChange={handleTabChange} orientation="vertical" keepMounted={false} px={20}>
        <Tabs.List>
          <Tabs.Tab value="general-info">General informations</Tabs.Tab>
          <Tabs.Tab value="identification">Identification documents to upload</Tabs.Tab>
          <Tabs.Tab value="poa">POA</Tabs.Tab>
          <Tabs.Tab value="info-contact">Info contact</Tabs.Tab>
        </Tabs.List>

        <Tabs.Panel value="general-info" px={30}>
          <ImporterViewGeneralInfo importer={importer} />
        </Tabs.Panel>
        <Tabs.Panel value="identification" px={30}>
          <ImporterViewIdentification importer={importer} />
        </Tabs.Panel>
        <Tabs.Panel value="poa" px={30}>
          <ImporterViewPOA importer={importer} />
        </Tabs.Panel>
        <Tabs.Panel value="info-contact" px={30}>
          <ImporterViewInfo />
        </Tabs.Panel>
      </Tabs>
    </>
  );
};
